module.exports = __webpack_public_path__ + "public/static/img/img-section2-1.1ddb54e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-section2-1.svg
// module id = A8/M
// module chunks = 1